import activate from './activate/store';
import service from './service/store';
import matrix from './matrix/store';
import logs from './logs/store';
import common from './common/store';

export default {
  namespaced: true,
  modules: { activate, service, matrix, logs, common },
};
